/** Cloud segment in external Salesforce cosell referral create URLs (lowercase). */
const normalizeSalesforceCosellCloudSegment = (
  cloudProvider: string
): string => cloudProvider.toLowerCase()

/** Relative segment: `cosell/:cloud/:accountId/referral/:referralId/details`. */
export function buildSalesforceCosellReferralDetailsCosellSegment(
  referralId: string,
  cloudAccountId: string,
  cloudProvider: string
): string {
  const cloud = normalizeSalesforceCosellCloudSegment(cloudProvider)
  return `cosell/${cloud}/${cloudAccountId}/referral/${referralId}/details`
}
